import { FormikErrors } from 'formik';

import { FormSection } from '@@/form-components/FormSection';
import { FormControl } from '@@/form-components/FormControl';
import { Input } from '@@/form-components/Input';

import { FormValues } from '../types';

interface Props {
  releaseName: string;
  errors: FormikErrors<FormValues>;
}

export function DeploymentSection({ releaseName, errors }: Props) {
  return (
    <FormSection title="Deploy to">
      <FormControl
        label="Release name"
        errors={errors.helmReleaseName}
        required
        tooltip="Automatically generated based on edge stack name (edge-<name>)"
      >
        <Input
          value={releaseName}
          onChange={() => {}} // No-op, read-only
          placeholder="e.g. edge-myapp"
          data-cy="helm-release-name-input"
          readOnly
          disabled
        />
      </FormControl>
    </FormSection>
  );
}
